/**
 * Ends the Meetings chat when the reader leaves the Notetaker
 * (notetaker-documents-parity R15, Gerry: "if you leave the notetaker tab, it
 * should close the chat and not be openable again unless you go to 'Chats'").
 * Mounted once, beside the app's routes, because no Notetaker page outlives
 * the navigation away from it. Renders nothing.
 */
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { forgetDockMemory, isNotetakerPath } from "./chatMemory";

export default function NotetakerChatLifetime(): null {
  const { pathname } = useLocation();
  useEffect(() => {
    if (!isNotetakerPath(pathname)) forgetDockMemory();
  }, [pathname]);
  return null;
}
